export const getObjectOfPublicEnvs = (): Record<string, string> => {
  const publicEnvs = Object.entries(process.env).filter((entry): entry is [string, string] => {
    const [key, value] = entry
    return key.startsWith('NEXT_PUBLIC_') && typeof value === 'string'
  })

  return Object.fromEntries(publicEnvs)
}
